import React, { useMemo, useState } from 'react';

import { Box, Stack, Typography, Fab, Tab, Tabs } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { TypoPoppins } from '../../Components/Typo';

import { ORDER_STATUS } from '../../Constant/Enums';

import { useAuthContext } from '../../Context/AuthContext';

import Layout from './Components/Layout';
import useUserOrders from './Components/useUserOrders';
import JobRequestsResponseCard from './Components/JobRequestsResponseCard';

const JobRequests = () => {
  const { user } = useAuthContext();

  const { orders, updateOrders, hasErrored } = useUserOrders(
    // user.userID,
    // useMemo(() => [ORDER_STATUS.AWAIT_APPROVAL], [])
  );

  const [isResponseBackToTopVisible, setIsResponseBackToTopVisible] = useState(false);

  function handleScrollToTop(event) {
    event.currentTarget.parentElement?.scroll({ top: 0, behavior: 'smooth' });
  }

  function handleScrollToTopVisibility(event) {
    const shouldBackToTopGetVisible = event.currentTarget.scrollTop > 100;
    if (shouldBackToTopGetVisible !== isResponseBackToTopVisible)
      setIsResponseBackToTopVisible(shouldBackToTopGetVisible);
  }

  return (
    <Layout>
      <Box
        display={{ xs: 'flex', md: 'initial' }}
        flexDirection={{ xs: 'column', md: 'initial' }}
        alignItems={{ xs: 'center', md: 'initial' }}
        justifyContent={{ xs: 'center', md: 'initial' }}
        flexGrow='1'>
        <Tabs
          value={TABS.RESPONSE}
          sx={{
            mb: 2,
            position: 'relative',
            borderRadius: '4px',
          }}
          TabIndicatorProps={{
            sx: ({ palette }) => ({
              borderRadius: '4px',
              zIndex: '-1',
              height: '100%',
              position: 'absolute',
              bgcolor: palette.white3.main,
            }),
          }}>
          <Tab
            disableTouchRipple
            value={TABS.RESPONSE}
            label={<TypoPoppins textTransform='none'>Waiting for Response</TypoPoppins>}
          />
        </Tabs>

        {hasErrored && (
          <Typography color='text.secondary' variant='h6' variantMapping={{ h6: 'p' }}>
            Failed to load data, Please refresh the page to try again.
          </Typography>
        )}

        {!hasErrored && orders.length > 0 && (
          <Box position='relative' width='fit-content'>
            <Stack
              gap={2}
              maxHeight='500px'
              overflow='auto'
              px={{ xs: 1, md: 'unset' }}
              pr={{ md: 2 }}
              pb={4}
              onScroll={handleScrollToTopVisibility}>
              {orders.map(order => (
                <Box flexShrink={0} maxWidth='550px' key={order.id}>
                  <JobRequestsResponseCard data={order} updateParentCards={updateOrders} />
                </Box>
              ))}
              {isResponseBackToTopVisible && (
                <Fab
                  size='small'
                  sx={{ position: 'absolute', right: '16px', bottom: '8px' }}
                  onClick={handleScrollToTop}>
                  <ArrowUpwardIcon />
                </Fab>
              )}
            </Stack>
          </Box>
        )}

        {!hasErrored && orders.length === 0 && (
          <Typography color='text.secondary' variant='h6'>
            No any items available
          </Typography>
        )}
      </Box>
    </Layout>
  );
};

const TABS = Object.freeze({
  RESPONSE: 'RESPONSE',
  ADVANCE: 'ADVANCE',
});

export default JobRequests;
